import React from "react";
import Navbar2 from "../Components/Navbar2";
import CampCard from "../Components/CampCard";
import Footer from "../Components/Footer";
import FeatureCard from "../Components/FeatureCard";

function VolleyballCamps2() {
  return (
    <>
      <Navbar2 />
      <div className="container-fluid px-0 pt-5">
        <div className='h1 text-center pb-5'>
          VOLLEYBALL CLINICS &amp; CAMPS
        </div>        
          <div className="row w-100">
            <div className="col">
              <div className="h1 text-center">
              VOLLEYBALL CLINICS
              </div>
              <div className="h4 pb-3 ms-5 me-5 fw-light">
              Where athletes can sharpen their skills, train with experienced coaches,
              and enjoy open play in a fun, flexible environment.
            </div>
            </div>
          </div>
      {/* Volleyball Clinics */}
      <div className="row row-cols-1 row-cols-md-3 rows-col-lg-3 g-3">
        {/* <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/skills_camp.jpg"
              title={<>15u - 16u All Skills Clinic</>}
              buttonText="VIEW CLINICS"
              linkUrl="https://adssportscomplex.leagueapps.com/events/4709314-15u---16u-all-skills-clinics"
              date_time={<>Sep 14 - Oct 26</>}
              // regularPrice={<>Regular Price $20.00</>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
            />
          </div> */}

        <div className='col'>
            <CampCard 
              backgroundImage="./s3/skills_camp.jpg"
              title={<>13u-16u Setting & Hitting Boot Camps</>}
              buttonText="VIEW CLINICS"
              linkUrl="http://adssportscomplex.leagueapps.com/events/4862266-13u-16u-setting--hitting-boot-camps"
              location={<>Kitty Hawk Middle School - Gymnasium<br/>
                840 Cimarron Trail<br/>
                Universal City, TX 78148<br/>
                <a href="https://maps.app.goo.gl/Nvy6ReVtA6STvcEK9" 
                  alt="" 
                  target="_blank"
                  className="mt-2 btn btn-advertise" rel="noreferrer"
                  >
                    Click Here for Map</a>
                </>}
              regularPrice={<>$20 Clinic Fee</>}
              
            />
          </div>
          <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/middle_school_camp.jpg"
              title={<>13u-16u Defense & Serve Receive Boot Camps</>}
              buttonText="VIEW CLINICS"
              linkUrl="http://adssportscomplex.leagueapps.com/events/4862191-13u-16u-defense--serve-receive-boot-camps"
              
              regularPrice={<>$20 Clinic Fee</>}
              location={<>Kitty Hawk Middle School - Gymnasium<br/>
                840 Cimarron Trail<br/>
                Universal City, TX 78148<br/>
                <a href="https://maps.app.goo.gl/Nvy6ReVtA6STvcEK9" 
                  alt="" 
                  target="_blank"
                  className="mt-2 btn btn-advertise" rel="noreferrer"
                  >
                    Click Here for Map</a>
                </>}
            />
          </div>
          
          <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/feature_clinics_opengym.jpg"
              title={<>7u to 12u Passing & Serve Receive</>}
              buttonText="VIEW CLINICS"
              linkUrl="http://adssportscomplex.leagueapps.com/events/4755328-7u---12u-passing--serve-receive-w-30-mins-of-serving"
              location={<>Kitty Hawk Middle School - Gymnasium<br/>
                840 Cimarron Trail<br/>
                Universal City, TX 78148<br/>
                <a href="https://maps.app.goo.gl/Nvy6ReVtA6STvcEK9" 
                  alt="" 
                  target="_blank"
                  className="mt-2 btn btn-advertise" rel="noreferrer"
                  >
                    Click Here for Map</a>
                </>}
              regularPrice={<>$20 Clinic Fee</>}
            />
          </div>
          <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/feature_volleyball.jpg"
              title={<>7u to 12u Setting and Hitting</>}
              buttonText="VIEW CLINICS"
              linkUrl="http://adssportscomplex.leagueapps.com/events/4755396-7u---12u-setting--hitting-w-30-mins-of-serving"
              location={<>Kitty Hawk Middle School - Gymnasium<br/>
                840 Cimarron Trail<br/>
                Universal City, TX 78148<br/>
                <a href="https://maps.app.goo.gl/Nvy6ReVtA6STvcEK9" 
                  alt="" 
                  target="_blank"
                  className="mt-2 btn btn-advertise" rel="noreferrer"
                  >
                    Click Here for Map</a>
                </>}
              regularPrice={<>$20 Clinic Fee</>}
            />
          </div>
      </div>

        {/* Volleyball Camps   */}
        <div className="row w-100 pt-5 mt-3">
            <div className="col">
              <div className="h1 text-center">
              VOLLEYBALL CAMPS
              </div>
               <div className="h4 ms-5 me-5 pb-3 fw-light">
                Join our Volleyball Camps for ages 5–16!
                Perfect for beginners and intermediate players, each camp
                builds core skills, game strategy, coordination, and teamwork.
                New sessions are added regularly—email us to learn more!
              </div>
            </div>
          </div>
        <div className="row w-100">         
          {/* <div className='col-sm-12 col-md-6 col-lg-6 pb-3'>
            <CampCard 
              backgroundImage="./s3/teeny_titan_camp.jpg"
              title={<>5U - 12U TEENY & MIGHTY TITANS</>}
              buttonText="REGISTER NOW"
              linkUrl="http://adssportscomplex.leagueapps.com/leagues/volleyball/4760662-5u---12u-teeny--mighty-titans---winter-session-i-6pm---730pm"
              date_time={<>Jan 13th, 20th, 27th<br/>Feb 3rd, 10th 17th<br/>6:00PM - 7:30PM</>}
              regularPrice={<>Regular Price $200 (includes a Titans T-shirt)</>}
              location={<>ADS Sport Complex</>}
              earlyBirdPrice={<>Early Bird Price $180</>}
            />
          </div> */}
          <div className='col-sm-12 col-md-6 col-lg-6 pb-3'>
            <CampCard 
              backgroundImage="./s3/high_school_camp.jpg"
              title={<>7U - 12U <br/>Titans Volleyball <br/>Training Academy </>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/clubteams/4682595-7u---12u-titans-training-academy"
              date_time={<>Oct 5 - Jan 7</>}
            />
          </div>
          <div className='col-sm-12 col-md-6 col-lg-6 pb-3'>
            <CampCard 
              backgroundImage="./s3/middle_school_camp.jpg"
              title={<>Late Bloomers Academy</>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/leagues/volleyball/4739608-12u--15u-late-bloomers-volleyball-academy"
              date_time={<>Nov 2 - Dec 7<br/>1:30PM - 3:30PM</>}
              location="Location TBD"
              regularPrice={<>Regular Price $300</>}
              earlyBirdPrice={<>Early Bird Price $270</>}
            />
          </div>
        </div>
      </div>
      <div className="row g-0 pb-5">
          <FeatureCard
            backgroundImage="./s3/feature_volleyball_tryouts.jpg"
            title="LOOKING FOR CLUB TRYOUTS?"
            linkUrl="/VolleyballTryouts"
            buttonText="CLICK HERE"
            fullWidth
          />
        </div>
      <Footer />
    </>
  );
}

export default VolleyballCamps2;
